export default [
  {
    id: 'main',
    urls: [
	    

		require('@/assets/img/01_brush.png'), 
		require('@/assets/img/eye.png'), 
	    require('@/assets/img/dossier-paper.png'),


	    /* QUESTION ROUTE */

    	/* timer */
	    require('@/assets/img/timer.png'),

	    /* bg */
		require('@/assets/img/question/result/bg/01_furious.jpg'), 
	    require('@/assets/img/question/result/bg/02_sad.jpg'),
	    require('@/assets/img/question/result/bg/03_angry.jpg'),
	    require('@/assets/img/question/result/bg/04_agitated.jpg'),
	    require('@/assets/img/question/result/bg/05_confused.jpg'),
	    require('@/assets/img/question/result/bg/06_mildly-amused.jpg'),
	    require('@/assets/img/question/result/bg/07_amused.jpg'),
	    require('@/assets/img/question/result/bg/08_happy.jpg'),
	    require('@/assets/img/question/result/bg/09_ecstatic.jpg'),

		require('@/assets/img/question/result/bg/error.png'),
 
		require('@/assets/img/question/result/distortion/amethyst.png'),
		require('@/assets/img/question/result/distortion/oxyer.png'),
		require('@/assets/img/question/result/distortion/rocks.png'),
		require('@/assets/img/question/result/distortion/face.jpg'),
		require('@/assets/img/question/result/distortion/pixel.jpg'),
		require('@/assets/img/question/result/distortion/mellow.jpg'),
		require('@/assets/img/silhouette.png'),

		require('@/assets/img/strange.jpeg'),
		require('@/assets/img/bubble.png'), 
		require('@/assets/sprites/bubbles.png'),
		require('@/assets/img/perlin-512.png'),
		require('@/assets/img/taphold.png'),

	    require('@/assets/img/question/result/btn_angry.png'),
	    require('@/assets/img/question/result/btn_sad.png'),
	    require('@/assets/img/question/result/btn_confused.png'),
	    require('@/assets/img/question/result/btn_happy.png'),


		/*character*/ 

		require('@/assets/sprites/faces.png'),


	    /* INTRO ROUTE */
 
	    require('@/assets/sprites/intro.png'),
	    require('@/assets/sprites/spaceship.png'),

	    /*cave*/

		require('@/assets/img/cave/wall-1.png'),
		require('@/assets/img/cave/wall-2.png'),
		require('@/assets/img/cave/wall-3.png'),
		require('@/assets/img/cave/wall-4.png'),
		require('@/assets/img/cave/wall-5.png'),
		require('@/assets/img/cave/wall-6.png'),
		require('@/assets/img/cave/wall-7.png'),
		require('@/assets/img/cave/wall-8.png'),

		/*entrance*/
		//require('@/assets/img/doors/bg2.png'),
		require('@/assets/img/doors/bg.png'),
		require('@/assets/img/doors/entrance.png'),
		require('@/assets/img/doors/ramp.png'),
		require('@/assets/img/doors/door-blade4.png'),

		/*alien eyes*/
		require('@/assets/sprites/one-eye.png'),
		require('@/assets/sprites/two-eye.png'),
		require('@/assets/sprites/three-eye.png'),
		require('@/assets/sprites/butterfly.png'),
		require('@/assets/img/alien-eyes.png'),
		require('@/assets/img/alien-eyes_cloud1.png'),
		require('@/assets/img/alien-eyes_cloud2.png'),
		require('@/assets/img/alien-eyes_cloud3.png'),
  
  	require('@/assets/img/surface-bg-bg.png'),
		require('@/assets/img/surface-bg.png'), 
		require('@/assets/img/surface-bg-two.png'),
		require('@/assets/img/surface-mg.png'),
		require('@/assets/img/surface-fg.png'),
		require('@/assets/img/sign-restricted-access.png'),
		require('@/assets/img/pipe.png'),
		require('@/assets/img/grit.png')

	]
  },
   {
    id: 'load',
    urls: [
	    require('@/assets/sprites/loader.png') 
	]
  }
]